import { isAriResourceIdValid } from '../is-ari-resource-id-valid';
import { isNotEmptyString } from '../is-not-empty-string';
export var selectSetValueValidator = function selectSetValueValidator(value) {
  return value === null || isNotEmptyString(value);
};
export var selectWithAriSetValueValidator = function selectWithAriSetValueValidator(value) {
  return value === null || isNotEmptyString(value) && isAriResourceIdValid(value);
};